"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextHelp = void 0;
const React = __importStar(require("react"));
const with_html_1 = __importDefault(require("react-markdown/with-html"));
const HelpOutline_1 = __importDefault(require("@material-ui/icons/HelpOutline"));
const context_help_styles_1 = require("./context-help-styles");
const tooltip_1 = require("../tooltip/tooltip");
function ContextHelp({ label, type = 'CLICKABLE' }) {
    const { root } = context_help_styles_1.useStyles();
    if (label === undefined || label === ' ') {
        return React.createElement(React.Fragment, null);
    }
    else {
        const content = React.createElement(with_html_1.default, { allowDangerousHtml: true, source: label !== null && label !== void 0 ? label : '' });
        return (React.createElement(tooltip_1.Tooltip, { title: content, placement: "top-start", type: type },
            React.createElement(HelpOutline_1.default, { className: root }),
            ";"));
    }
}
exports.ContextHelp = ContextHelp;
//# sourceMappingURL=context-help.js.map